import { http } from 'utils'

import {
  OrdersDetailsWestfieldCorpAPITypes,
  OrdersDetailsWestfieldCorpFetchParamsTypes,
} from 'types/orders-details-westfieldcorp'
import { OrdersDetailsWestfieldCorpAPISchemas } from 'schemas/orders-details-westfieldcorp-schemas'

import { DATASTATUS } from 'constants/status'

export async function postOrdersDetailsWestfieldCorpAPI({
  orderId,
}: OrdersDetailsWestfieldCorpFetchParamsTypes): Promise<OrdersDetailsWestfieldCorpAPITypes> {
  const url = `/orders/details/${orderId}`

  const response = await http.get<unknown>(url)
  const validatedData = OrdersDetailsWestfieldCorpAPISchemas.safeParse(
    response.data
  )

  console.log(validatedData.error, ' ERROR')

  if (!validatedData.success) {
    return {
      data: null,
      outcomeMessage: JSON.stringify(validatedData.error),
      ...DATASTATUS,
    }
  }
  return validatedData.data
}
